var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBankEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.69336 12.0839H12.2104",
    stroke: "#9BAEBC",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.09501 1.4998C7.61705 0.834679 8.46067 0.869388 9.12651 1.39143L10.1111 2.16351C10.7769 2.68555 11.0128 3.49518 10.4908 4.16172L4.61938 11.6523C4.42317 11.9031 4.12355 12.0511 3.8048 12.0547L1.54026 12.0837L1.02742 9.87726C0.955174 9.56772 1.02742 9.24189 1.22363 8.99043L7.09501 1.4998Z",
    stroke: "#9BAEBC",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.99609 2.90259L9.39184 5.5645",
    stroke: "#9BAEBC",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBankEdit);
export default __webpack_public_path__ + "static/media/BankEdit.e9b2863ecb4b89db9f6a9743aefb4667.svg";
export { ForwardRef as ReactComponent };